/** Russian display names for official + core catalog packs. IDs stay English. */

export const RU_PACK_NAMES: Record<string, string> = {
  'web-access-control': 'Доступ в вебе',
  'authentication-security': 'Вход и пароли',
  'session-security': 'Сессии',
  'jwt-oauth-oidc': 'JWT / OAuth / OIDC',
  'api-authorization': 'Права в API',
  'api-abuse-resource-control': 'Нагрузка и злоупотребление API',
  'api-inventory-versioning': 'Инвентарь и версии API',
  'third-party-api-trust': 'Чужие API',
  'sql-nosql-injection': 'SQL / NoSQL-инъекции',
  'command-code-injection': 'Инъекции команд',
  'xss-html-dom': 'XSS / HTML / DOM',
  'csrf-cors-origin': 'CSRF / CORS / Origin',
  'ssrf-url-fetching': 'SSRF / запросы по URL',
  'path-file-security': 'Пути и файлы',
  'serialization-parser-security': 'Сериализация и парсеры',
  'crypto-modern': 'Криптография',
  'secrets-hygiene': 'Секреты в коде',
  'sensitive-data-privacy': 'Личные данные',
  'security-headers': 'Заголовки безопасности',
  'redirect-forward-routing': 'Редиректы и маршруты',
  'business-logic-integrity': 'Бизнес-логика',
  'workflow-state-machine': 'Состояния и сценарии',
  'race-condition-concurrency': 'Гонки и параллельность',
  'money-billing-financial': 'Деньги и счета',
  'multi-tenancy-isolation': 'Изоляция арендаторов',
  'error-exception-safety': 'Ошибки и исключения',
  'logging-audit-alerting': 'Логи и алерты',
  'dependency-vulnerability': 'Уязвимые зависимости',
  'supply-chain': 'Цепочка поставки',
  'ci-cd-security': 'CI/CD',
  'artifact-integrity-slsa': 'Целостность артефактов / SLSA',
  'sbom-license-governance': 'SBOM и лицензии',
  'docker-security': 'Docker',
  'docker-compose-security': 'Docker Compose',
  'kubernetes-security': 'Kubernetes',
  'helm-security': 'Helm',
  'terraform-security': 'Terraform',
  'ansible-security': 'Ansible',
  'network-exposure': 'Сеть наружу',
  'cloud-iam-least-privilege': 'Облачные права (IAM)',
  'aws-security': 'AWS',
  'azure-security': 'Azure',
  'gcp-security': 'GCP',
  'database-security': 'Базы данных',
  'cache-queue-security': 'Кэш и очереди',
  'websocket-realtime-security': 'WebSocket / realtime',
  'graphql-security': 'GraphQL',
  'grpc-protobuf-security': 'gRPC / Protobuf',
  'frontend-client-security': 'Фронтенд',
  'python-security': 'Python',
  'javascript-typescript-security': 'JavaScript / TypeScript',
  'java-security': 'Java',
  'dotnet-security': '.NET',
  'go-security': 'Go',
  'php-security': 'PHP',
  'memory-safety-native': 'Память / native',
  'regex-parser-dos': 'Regex / DoS парсера',
  'performance-resource-leaks': 'Утечки ресурсов',
  'availability-resilience': 'Доступность',
  'observability-operability': 'Наблюдаемость',
  'configuration-security': 'Конфиги',
  'secure-defaults-fail-closed': 'Безопасные значения по умолчанию',
  'privacy-compliance-code': 'Приватность в коде',
  'email-notification-security': 'Почта и уведомления',
  'upload-media-processing': 'Загрузка файлов',
  'template-document-generation': 'Шаблоны и документы',
  'git-source-control-security': 'Git',
  'test-fixture-security': 'Тестовые фикстуры',
  'mobile-security': 'Мобильные приложения',
  'llm-genai-security': 'LLM / GenAI',
  'agentic-ai-security': 'Агенты / MCP',
  'ai-code-risk': 'Риск ИИ-кода',
  'architecture-trust-boundaries': 'Границы доверия',
  'security-design-invariants': 'Инварианты дизайна',
  'data-integrity': 'Целостность данных',
  'input-validation-boundaries': 'Проверка ввода',
  'integer-numeric-safety': 'Числа и переполнения',
  'time-date-expiration': 'Время и сроки',
  'cache-security': 'Кэш',
  'admin-control-plane': 'Админка',
  'backup-recovery-security': 'Бэкапы',
  'infrastructure-drift': 'Дрейф инфраструктуры',
  'deployment-gates': 'Гейты выкладки',
  'security-regression': 'Регрессии безопасности',
  'reviewer-meta-quality': 'Качество ревью',
  'secrets-leaked': 'Утёкшие секреты',
  'injection': 'Инъекции',
  'auth-session': 'Вход и сессия',
  'access-control': 'Сломанный доступ',
  'ssrf-redirect': 'SSRF и открытый редирект',
  'crypto-misuse': 'Криптография',
  'insecure-deserialization': 'Десериализация',
  'file-upload': 'Загрузка файлов',
  'dependency-cve': 'Уязвимые зависимости',
  'dependency-typosquat': 'Вредоносные / опечаточные пакеты',
  'python-web': 'Python, веб',
  'python-quality': 'Python, ошибки',
  'node-web': 'Node / TypeScript, веб',
  'node-quality': 'JavaScript, ошибки',
  'dockerfile-hardening': 'Dockerfile',
  'compose-expose': 'Docker Compose',
}
